import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import $ from 'jquery';
import deviderimg from "../images/devider-white.png"

export default class Contact extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content contact-content">    
            <div className='contact-banner'>
              <div className="contact-banner-content">
                <h3>contact us</h3>
                <div className="devider"><img src={deviderimg} /></div>
                <p>We would love to hear from you...</p>
              </div>
            </div>
            <div className="container contact-form">
              <div className='row'>
                <div className='col-lg-6'>
                    <div className='subhead text-left' style={{color:"#666"}}>For more information, please contact us at :</div>
                    <div className='mt-4'>
                      <p><strong>E-mail:</strong> learning@ivanooo.com</p>
                    </div>
                </div>
                <div className='col-lg-6'>
                  <form className='form-main-wrapper p-0'>
                    <div className='subhead text-left' style={{color:"#666"}}>Or drop us a line here :</div>
                    <div className="form-group">
                      <input type="email" className="form-control" placeholder="Your Name*" />
                      <small className="text-danger">Please enter your name.</small>
                    </div>
                    <div className="form-group">
                      <input type="email" className="form-control" placeholder="Your Email*" />
                      <small className="text-danger">Please enter your email address.</small>
                    </div>
                    <div className="form-group">
                      <input type="email" className="form-control" placeholder="Your Phone*" />
                      <small className="text-danger">Please enter your phone number.</small>
                    </div>
                    <div className="form-group">
                      <textarea className="form-control" placeholder="Your Message*" ></textarea>
                      <small className="text-danger">Please enter a message.</small>
                    </div>
                    <div className="form-group mt-4">
                      <button type="submit" className="btn btn-theme-rect">SEND MESSAGE</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            
        </div>
        <Footer></Footer>
        
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/ivano/contact.jsx